module.exports = __webpack_public_path__ + "7461bfa0089e2f0b39ca08ce4a7d76b2.png";